import { MemberPermissionType } from './Member';
import { Role } from './Role';
import { Team } from './Team';
import { User } from './User';
import { Workspace } from './Workspace';

export enum WorkspaceInvitationStatusType {
    PENDING = 'Pending',
    ACCEPTED = 'Accepted',
    REVOKED = 'Revoked',
    EXPIRED = 'Expired',
}

export interface WorkspaceInvitation {
    id: string;
    workspace: Workspace;
    invitedBy: User;
    customRole?: Role;
    team?: Team;
    emailAddress: string;
    permission: MemberPermissionType;
    tokenHash: string;
    status: WorkspaceInvitationStatusType;
    expiresAt: Date;
    createdAt: Date;
    updatedAt: Date;
}
